import React from "react";
import Space from "./Space";

export default function Status(props) {

    const { type = "" } = props;

    let _class = "ui-status active";
  

    return (
        <div className={_class}>{props.children}</div>
    )
}